<span class="plan-status-pill" [class]="'plan-status-pill--' + modifier()">
  <span class="plan-status-pill__dot" aria-hidden="true"></span>
  {{ labelKey() | translate }}
</span>
